import { render, staticRenderFns } from "./CustomDropZone.vue?vue&type=template&id=4f377548&scoped=true&"
import script from "./CustomDropZone.vue?vue&type=script&lang=js&"
export * from "./CustomDropZone.vue?vue&type=script&lang=js&"
import style0 from "./CustomDropZone.vue?vue&type=style&index=0&id=4f377548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f377548",
  null
  
)

export default component.exports